export class UpdateLimiteProduit
{
    limiteProduitId:number;
    limiteAutorise: number;
}